
import { SET_DISCOUNT_TYPE , SET_DISCOUNT_CODE } from "../actions/Discounts.action";
import {IDiscountType} from "../interfaces/IDiscounts";
export interface IDiscountsState {
    selectedType:IDiscountType,
    code:string
};
const initialState ={
    selectedType:IDiscountType.PERCENTAGE,
    code:""
}

export function DiscountsReducer(state: IDiscountsState=initialState, action: any) {
    switch (action.type) {
        case SET_DISCOUNT_TYPE:
            return {
                ...state,
                selectedType: action.payload
            }
        case SET_DISCOUNT_CODE:
            return {
                ...state,
                code: action.payload
            }
        default:
            return { ...state };
    }
};